import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import FuseTheme from '../global/theme';
import IconButton from 'material-ui/IconButton';
import ContentCreate from 'material-ui/svg-icons/content/create';

const styles = {
    icon: {overflow: 'inherit'},
};

const EditButton = ({ basePath = '', record = {} }) => (
    <IconButton
        containerElement={<Link to={`${basePath}/${record.id}`} />}
        style={styles.icon}
    >
        <ContentCreate color={FuseTheme.palette.primary1Color} />
    </IconButton>
);

EditButton.propTypes = {
    basePath: PropTypes.string,
    record: PropTypes.object,
};

EditButton.defaultProps = {
    style: { padding: 0 },
};

export default EditButton;


// WEBPACK FOOTER //
// ./src/Fuse/buttons/EditButton.js